export const convertToUpperCase = (data) => {
  if (!["bl", "TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT)) {
    return data;
  }

  if (data === null || data === undefined) return data;

  if (typeof data === "string") {
    return data.toUpperCase();
  }

  if (Array.isArray(data)) {
    return data.map((item) => convertToUpperCase(item));
  }

  if (typeof data === "object") {
    let updatedObj = {};

    for (let key in data) {
      updatedObj[key] = convertToUpperCase(data[key]);
    }

    return updatedObj;
  }

  return data;
};